import AuthRoute from "shared/routes/authRoute";
import Toast from "shared/components/common/toast";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import "shared/utils/theme.scss";
import "./App.scss";
// import { store } from "shared/redux/store";

function App() {
  const {
    theme: { theme },
  } = useSelector((state: any) => state?.root);
  useEffect(() => {
    document.documentElement.setAttribute("theme-mode", "light");
  }, [theme]);
  return (
    <div className="App">
      {/* <Provider store={store}> */}
      <AuthRoute />
      <Toast />
      {/* </Provider> */}
    </div>
  );
}

export default App;
